<h1>{{data.rules.title}}</h1>
<div mat-dialog-content>
  <pbg-trivia-rules *ngIf="data.game === GameKeys.Trivia"></pbg-trivia-rules>
  <pbg-liars-dice-rules *ngIf="data.game === GameKeys.LiarsDice"></pbg-liars-dice-rules>
  <pbg-telestration-rules *ngIf="data.game === GameKeys.Telestrations"></pbg-telestration-rules>
  <pbg-scattergories-rules *ngIf="data.game === GameKeys.Scattergories"></pbg-scattergories-rules>
</div>
<div mat-dialog-actions>
  <button mat-button class="mat-raised-button mat-secondary" (click)="close()">Back</button>
  <button mat-button class="mat-raised-button mat-primary" (click)="goToGame(data.rules.route)" cdkFocusInitial>Play!</button>
</div>
